export default __webpack_public_path__ + "static/media/box_sticker_original.6a8cfe9d.jpg";